import { Ellipsis, SquarePen, Trash2 } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function MetaDatasetTableActions({
  dataset,
  canManage = false,
  onEdit = () => {},
  onDelete = () => {},
}) {
  if (!canManage) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label="Dataset actions"
        className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
      >
        <Ellipsis />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="tw:w-auto">
        <DropdownMenuItem onClick={() => onEdit(dataset)}>
          <SquarePen />
          Edit
        </DropdownMenuItem>
        <DropdownMenuItem
          variant="destructive"
          onClick={() => onDelete(dataset)}
        >
          <Trash2 />
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
